/**
 * Success Skills Academic Development standards for Assignment Submission Status
 * Links On Time, Late, and Incomplete submissions to grade-band specific Missouri Success Skills standards.
 */

export const SUBMISSION_STATUSES = [
  { id: 'on_time', label: 'On Time', color: 'green', defaultScore: 95, defaultColor: 'green' },
  { id: 'late', label: 'Late', color: 'yellow', defaultScore: 70, defaultColor: 'yellow' },
  { id: 'incomplete', label: 'Incomplete', color: 'red', defaultScore: 45, defaultColor: 'red' },
];

export const SUCCESS_SKILLS_STANDARDS_BY_BAND = {
  'K-2': [
    {
      code: 'K-2.AD.1.A.c.',
      cleanCode: 'K-2.AD.1.A.c',
      description: 'Demonstrate skills needed to complete classroom routines, assignments, and activities.',
      strand: 'Academic Achievement',
      cluster: 'Academic Skills',
    },
  ],
  '3-5': [
    {
      code: '3-5.AD.1.B.c.',
      cleanCode: '3-5.AD.1.B.c',
      description: 'Demonstrate time-management and organizational techniques for assignments and task completion.',
      strand: 'Academic Achievement',
      cluster: 'Academic Self-Management',
    },
  ],
  '6-8': [
    {
      code: '6-8.AD.1.B.c.',
      cleanCode: '6-8.AD.1.B.c',
      description: 'Adapt time management and organizational skills to meet the needs of middle school.',
      strand: 'Academic Achievement',
      cluster: 'Academic Self-Management',
    },
  ],
  '9-12': [
    {
      code: '9-12.AD.1.B.a.',
      cleanCode: '9-12.AD.1.B.a',
      description: 'Adapt time management and organizational skills to meet the needs of high school.',
      strand: 'Academic Achievement',
      cluster: 'Academic Self-Management',
    },
  ],
};

/**
 * Determine the appropriate grade band from a grade level string (e.g., 'Grade 3', 'K', '6', '10')
 */
export function getGradeBandForGrade(grade) {
  if (grade == null || String(grade).trim() === '') return null;
  const str = String(grade).toUpperCase().replace(/^GRADE\s*/i, '').trim()
    .replace(/\s+TO\s+/, '-').replace(/\s*-\s*/, '-');

  if (['PK', 'K', 'KINDERGARTEN', '0', '1', '2', 'K-2'].includes(str)) return 'K-2';
  if (['3', '4', '5', '3-5'].includes(str)) return '3-5';
  if (['6', '7', '8', '6-8'].includes(str)) return '6-8';
  if (['9', '10', '11', '12', '9-10', '11-12', '9-12'].includes(str)) return '9-12';

  return null;
}

/**
 * Get primary Success Skills standards for a given grade level or grade band
 */
export function getSuccessSkillsForGrade(grade) {
  const band = getGradeBandForGrade(grade);
  return SUCCESS_SKILLS_STANDARDS_BY_BAND[band] || [];
}
